import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS_CATEGORIAS_DOCUMENTO } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminCategoriasDocumentoPage } from "@/features/admin-categorias-documento/components/AdminCategoriasDocumentoPage";
import { categoriasDocumentoAdminQueryOptions } from "@/features/admin-categorias-documento/hooks/use-categorias-documento-admin";

/** Ruta `/admin/categorias-documento` · CRUD del catálogo de categorías de documento. */
export const Route = createFileRoute("/_authed-tw/admin/categorias-documento")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion(PERMISOS_CATEGORIAS_DOCUMENTO)
      ? queryClient.ensureQueryData(categoriasDocumentoAdminQueryOptions({ page: 1, pageSize: 15 }))
      : undefined,
  component: () => (
    <PermissionGate permisos={PERMISOS_CATEGORIAS_DOCUMENTO}>
      <AdminCategoriasDocumentoPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
